import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {Observable} from 'rxjs';
import {CardDeck, DeckType, LinkageType} from '../../shared/card-deck';
import {MatSidenav} from '@angular/material/sidenav';
import {RecommendedGameDesign} from '../../design-recommender/shared/recommended-game-design';
import {GameDesign} from '../../design-recommender/shared/game-design';
import {UserValidation} from '../../shared/user-validation';
import {AttributionType} from '../../deck-explorer/shared/attribution-types.enum';
import {CardStoreService} from '../../shared/card-store.service';
import {RecommendationService} from '../../design-recommender/shared/recommendation.service';
import {GameDesignService} from '../../design-recommender/shared/game-design.service';
import {AttributionService} from '../../deck-explorer/shared/attribution.service';
import {CardWebService} from '../../shared/card-web.service';
import {CardWeb} from '../../shared/card-web';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CardWebElement} from '../../shared/card-web-element';
import {CustomObjectsService} from '../../shared/custom-objects.service';
import {MatDialog} from '@angular/material/dialog';
import {NoteDialogElementComponent} from '../note-dialog-element/note-dialog-element.component';
import {CustomObjects} from '../../shared/custom-objects';
import {NoteDialogRelationComponent} from '../note-dialog-relation/note-dialog-relation.component';
import {GameDesignRelation} from '../../design-recommender/shared/game-design-relation';
import {MessageFactoryService} from '../../shared/message-factory.service';
import {ObjectExtractingServiceService} from '../../shared/object-extracting-service.service';
import {CardWebConnectorService} from '../../shared/card-web-connector.service';
import {ConnectorMessageType} from '../../shared/connector-message.type';
import {ConnectorMessage} from '../../shared/connector-message';
import {ElementLock, ElementLockType} from '../shared/ElementLock';
import {CommunityConnectorService} from '../../shared/community-connector.service';
import {CommunityMember} from '../../shared/CommunityMember';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'em-svg-viewer',
  templateUrl: './svg-viewer.component.html',
  styleUrls: ['./svg-viewer.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({opacity: 0})), // Initial state
      transition('void <=> *', [ // Transition between void (hidden) and any state (visible)
        animate('300ms ease-in-out'), // Animation duration and easing
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgViewerComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private cs: CardStoreService,
    private rs: RecommendationService,
    private gs: GameDesignService,
    private cos: CustomObjectsService,
    private as: AttributionService,
    private cws: CardWebService,
    private mfs: MessageFactoryService,
    private oes: ObjectExtractingServiceService,
    private cwc: CardWebConnectorService,
    private ccc: CommunityConnectorService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private noteDialog: MatDialog
  ) {
    this.cs.getUserLoginListener().subscribe(b => {
      if (b === undefined) {
        this.ngOnDestroy();
        this.recommendedGameDesign = undefined;
        this.gameDesign = undefined;
        this.cardDeck$ = undefined;
        this.userValidation$ = undefined;
        this.cardWeb = undefined;
        this.customObjects = undefined;
      }
    });
  }
  protected readonly Array = Array;
  @ViewChild('svgContainer') svgContainer!: ElementRef<SVGSVGElement>;
  @ViewChild('svgPlusSignLeft') svgPlusSignLeft!: ElementRef<SVGSVGElement>;
  @ViewChild('svgPlusSignRight') svgPlusSignRight!: ElementRef<SVGSVGElement>;
  @ViewChild('svgPlusSignBottom') svgPlusSignBottom!: ElementRef<SVGSVGElement>;
  gridDragStartX = 0;
  gridDragStartY = 0;
  cardDragStartX = 0;
  cardDragStartY = 0;

  private CACHE_SIZE = 1;

  dialogCardNoteIsOpen = false;
  dialogLinkNoteIsOpen = false;

  pointerEventClickX = 0;
  pointerEventClickY = 0;

  shareOption = 'edit';

  sideNavIsOpen = false;

  private ownCommunityMember: CommunityMember;

  viewBoxX = 10000;
  viewBoxY = 6000;
  viewBoxWidth = 800;
  viewBoxHeight = 800;
  zoomFactor = 1;
  zoomLevel = 100;

  cardDrag = false;
  gridDrag = false;
  plusSignDrag = false;
  // plusSignNoDrag is needed to have the side menue opened if there is no neighbourcard and no dragEvent possible
  plusSignNoDrag = false;
  draggedCard: any = null;
  selectedWebElement: CardWebElement = null;

  guestList: Map<number, CommunityMember> = new Map<number, CommunityMember>();

  showHoverCard = false;
  hoveredGridX = 0;
  hoveredGridY = 0;

  plusSignX = 100;
  plusSignY = 100;
  mouseMoveDragLeft = 0;
  mouseMoveDragRight = 0;
  mouseMoveDragBottom = 0;
  collisionCoordinate = 0;
  initialMousePos = 0;
  dragDirectionPlusSign: ('left' | 'right' | 'bottom');
  mouseMoveDragTargetCardId = 0;

  isCardSelected = false;
  selectedCardId = 0;
  selectedCardDeckId = 0;
  selectedCardDeckType: DeckType = null;

  isConnectionSelected = false;
  selectedConnection = {
    sourceId: null,
    targetId: null,
    posX: null,
    posY: null,
    pos: null,
    relationItemId: null,
    obstaclePatternType: null,
    isLinkageConnection: null,
  };

  cardDeck$: Observable<CardDeck>;

  cardWeb: CardWeb;
  customObjects: CustomObjects;

  @Input() cardDeckIdSelection: number;
  @Input() rightSidenav: MatSidenav;
  recommendedGameDesign: RecommendedGameDesign;
  gameDesign: GameDesign;

  userValidation$: Observable<UserValidation>;

  attribution: AttributionType;
  subAttribution: AttributionType;
  recommendationSorting: boolean;

  lockCardMap: Map<number, ElementLock> = new Map();
  // With private ensure that the functions are called to add and remove linkLockElements
  private lockLinkMap: Map<string, ElementLock> = new Map();

  protected readonly DeckType = DeckType;

  ngOnDestroy() {
    // CALL WEBHOOK CONNECTION
    const messageObject = this.mfs.createMessageLeaveDesign();
    this.oes.handleAction(messageObject);
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {

    this.as.getAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.attribution = attributionType;
      }
    );
    this.as.getSubAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.subAttribution = attributionType;
      }
    );
    this.cs.getUserLoginListener().subscribe(b => {
      this.userValidation$ = b;
    });
    // Ensure that the GameDesign is initizalized with ALL cardDecks
    // and not only with the one derived from the routing param
    this.userValidation$.subscribe(userValidation => {
      for (const cardDeck of userValidation.carddecks) {
        this.gs.initGameDesign(cardDeck.id, cardDeck.type);

        this.gameDesign = this.gs.getGameDesign();
        this.gs.getGameDesignBehaviorSubject().subscribe(gameDesign => {
          this.gameDesign = gameDesign;
          // TODO: CallStack Error
        });

        // Changes in the game design should cause new recommendations
        if (!this.rs.checkIfRecommendationRequestIsPossible()) {
          this.rs.setGameDesignBehaviorSubject(this.gs.getGameDesignBehaviorSubject());
        }

        // Changes in the recommendation should change the recommended game design
        this.rs.getRecommendationBehaviorSubject().subscribe(recommendedGameDesign => {
          if (this.rs.hasRecommendation()) {
            this.recommendedGameDesign = recommendedGameDesign;
          } else {
            this.recommendedGameDesign = null;
          }
        });

        this.rs.getRecommendationSortingBehaviorSubject().subscribe(sort => {
          this.recommendationSorting = sort;
        });

      }
    });
    this.cws.loadCustomCardWeb(1);
    this.cws.getCustomCardWebBehaviorSubject().subscribe(cardWeb => {
      this.cardWeb = this.cws.getCustomCardWeb();
    });
    this.cos.getCustomObjectsBehaviorSubject().subscribe(customObject => {
      this.customObjects = customObject;
    });
    if (!this.mfs.isInitialized()) {
      this.mfs.initialize(this.cardWeb.name, this.cardWeb.createdDateTime);
      // CALL WEBSOCKET CONNECTION
    }

    // If user enters the svg viewer editor his communityMember with avatarTemplate
    // is fetched from CommunitySystem. This is needed to be added to the webSocketMessages to show avatar when
    // parts of the card network are locked
    this.ccc.checkUserByMail().subscribe(communityMember => {
      let messageObject: ConnectorMessage;
      if (communityMember.length > 0) {
        this.ownCommunityMember = communityMember[0];
        this.ccc.getAvatarByUserId(this.ownCommunityMember.id).subscribe(avatarMember => {
          this.ownCommunityMember = avatarMember;
          messageObject = this.mfs.createMessageEnterDesign(this.ownCommunityMember);
          this.oes.handleAction(messageObject);
        });
      }else{
        // If user is no community member he can work on its own also
        messageObject = this.mfs.createMessageEnterDesign();
        this.oes.handleAction(messageObject);
      }
    });

    this.cwc.getConnectorMessageEvent().subscribe( message => {
      this.handleConnectorMessage(message);
    });
  }

  private createCardLock(message: ConnectorMessage): ElementLock {
    return {lockType: ElementLockType.LOCK_CARD,
      cardObject: message.cardObject, userId: message.userId, communityMember: message.communityMember};
  }

  private createSourceCardLock(message: ConnectorMessage): ElementLock {
    const sourceCard = this.cws.getCardWebElement(message.linkObject.sourceId);
    const cardObject = this.mfs.buildCardObject(sourceCard.cardDeckId, sourceCard.id, sourceCard.cardDeckType, sourceCard.name);
    return {lockType: ElementLockType.LOCK_SOURCE_TARGET_CARD,
      cardObject, userId: message.userId, communityMember: message.communityMember};
  }

  private createTargetCardLock(message: ConnectorMessage): ElementLock {
    const targetCard = this.cws.getCardWebElement(message.linkObject.targetId);
    const cardObject = this.mfs.buildCardObject(targetCard.cardDeckId, targetCard.id, targetCard.cardDeckType, targetCard.name);
    return {lockType: ElementLockType.LOCK_SOURCE_TARGET_CARD,
      cardObject, userId: message.userId, communityMember: message.communityMember};
  }

  getLinkageCardElementLock(cardWebElement: CardWebElement): ElementLock {
    if (cardWebElement.cardDeckType === DeckType.linkage) {
      for (const linkLock of this.lockLinkMap.values()) {
        if (cardWebElement.linkageSourceIds.includes(linkLock.linkObject.sourceId)) {
          if (cardWebElement.linkageTargetIds.includes(linkLock.linkObject.targetId)) {
            return linkLock;
          }
        }
      }
    }
    return null;
  }

  private createLinkLock(message: ConnectorMessage): ElementLock {
    return {lockType: ElementLockType.LOCK_LINK,
      linkObject: message.linkObject, userId: message.userId, communityMember: message.communityMember};
  }

  getLinkLock(sourceId: number, targetId: number) {
    const key = this.createLinkLockKey(sourceId, targetId);
    return this.lockLinkMap.get(key);
  }

  hasLinkLock(sourceId: number, targetId: number) {
    const key = this.createLinkLockKey(sourceId, targetId);
    return this.lockLinkMap.has(key);
  }

  hasCardLock(card: CardWebElement) {
    if (this.lockCardMap.has(card.id)) {
      return true;
    }else {
      if (card.cardDeckType === DeckType.linkage) {
        const elementLock = this.getLinkageCardElementLock(card);
        return elementLock !== null;
      }
    }
    return false;
  }

  private addLinkLock(elementLock: ElementLock) {
    if (elementLock.linkObject !== null) {
      const key = this.createLinkLockKey(elementLock.linkObject.sourceId, elementLock.linkObject.targetId);
      this.lockLinkMap.set(key, elementLock);
    }
  }

  private removeLinkLock(sourceId: number, targetId: number) {
    const key = this.createLinkLockKey(sourceId, targetId);
    this.lockLinkMap.delete(key);
  }

  private tryToRemoveCardLock(cardId: number) {
    if (this.deleteCardLockPossible(cardId)) {
      this.lockCardMap.delete(cardId);
    }
  }

  private createLinkLockKey(sourceId: number, targetId: number) {
    return sourceId.toString().concat('_').concat(targetId.toString());
  }

  private unlockAllElementsLockedByUser(userid: string) {
    this.lockCardMap.forEach( (elementLock: ElementLock, key: number) => {
      if (elementLock.userId === userid) {
        this.tryToRemoveCardLock(key);
      }
    });
    this. lockLinkMap.forEach( (elementLock: ElementLock, key: string) => {
      if (elementLock.userId === userid) {
        this.lockLinkMap.delete(key);
      }
    });
  }

  private deleteCardLockPossible(lockedCardId) {
    let deleteCardLock = true;
    for (const elementLock of this.lockLinkMap.values()) {
      if (elementLock.linkObject.sourceId === lockedCardId ||
        elementLock.linkObject.targetId === lockedCardId) {
        deleteCardLock = false;
      }
    }
    return deleteCardLock;
  }

  handleConnectorMessage(message: ConnectorMessage) {
    // Try to update guestList first - should be part of every message
    this.updateGuestList(message);
    switch (message.connectorMessageType) {
      case ConnectorMessageType.EMPTY_MESSAGE:
        break;
      case ConnectorMessageType.SAVE_MESSAGE:
        if (message.shareOption !== null) {
          this.shareOption = message.shareOption;
        }
        console.log('SAVE MESSAGE ON RECEIVED MESSAGE');
        break;
      case ConnectorMessageType.LEAVE_DESIGN:
        this.unlockAllElementsLockedByUser(message.userId);
        if (message.communityMember !== null) {
          this.snackBar.open(message.communityMember.username + ' hat den Kartentisch verlassen.', '',
            {
              horizontalPosition: 'right',
              verticalPosition: 'bottom',
              duration: 3000
            });
        }
        console.log('LEAVE ON RECEIVED MESSAGE');
        break;
      case ConnectorMessageType.ENTER_DESIGN:
        if (message.communityMember !== null) {
          this.snackBar.open(message.communityMember.username + ' ist dem Kartentisch beigetreten.', '',
            {
              horizontalPosition: 'right',
              verticalPosition: 'bottom',
              duration: 3000
            });
        }
        console.log('ENTER DESIGN ON RECEIVED MESSAGE');
        break;
      case ConnectorMessageType.ENTER_LINK_NOTE:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            const elementLock: ElementLock = this.createLinkLock(message);
            this.addLinkLock(elementLock);
            // Add Lock to source and target cards as well - but only if there is no lock from other user
            if (!this.lockCardMap.has(message.linkObject.sourceId)) {
              const sourceCardLock = this.createSourceCardLock(message);
              this.lockCardMap.set(sourceCardLock.cardObject.id, sourceCardLock);
            }
            if (!this.lockCardMap.has(message.linkObject.targetId)) {
              const targetCardLock = this.createTargetCardLock(message);
              this.lockCardMap.set(targetCardLock.cardObject.id, targetCardLock);
            }
            console.log('LOCK LINK ON RECEIVED MESSAGE');
          }
        }
        break;
      case ConnectorMessageType.LEAVE_LINK_NOTE:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (this.hasLinkLock(message.linkObject.sourceId, message.linkObject.targetId)) {
              this.removeLinkLock(message.linkObject.sourceId, message.linkObject.targetId);
              console.log('UNLOCK LINK ON RECEIVED MESSAGE');
            }
            if (this.lockCardMap.has(message.linkObject.sourceId)) {
                // Check if there is another linkLock that needs this source card to be locked
                this.tryToRemoveCardLock(message.linkObject.sourceId);
            }
            if (this.lockCardMap.has(message.linkObject.targetId)) {
                // Check if there is another linkLock that needs this source card to be locked
                this.tryToRemoveCardLock(message.linkObject.targetId);
            }
          }
        }
        break;
      case ConnectorMessageType.ENTER_CARD_LINK:
      case ConnectorMessageType.ENTER_CARD_NOTE:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)){
            const elementLock: ElementLock = this.createCardLock(message);
            this.lockCardMap.set(message.cardObject.id, elementLock);
            console.log('LOCK CARD ON RECEIVED MESSAGE');
          }
        }
        break;
      case ConnectorMessageType.LEAVE_CARD_LINK:
      case ConnectorMessageType.LEAVE_CARD_NOTE:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)) {
            if (this.lockCardMap.has(message.cardObject.id)) {
              this.tryToRemoveCardLock(message.cardObject.id);
              console.log('UNLOCK CARD ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.RESET_DESIGN:
        this.cos.clearCustomObjects();
        this.cws.clearCustomCardWeb();
        this.gs.clearGameDesign();
        this.gs.clearGameDesignProblems();
        console.log('RESET DESIGN ON RECEIVED MESSAGE');
        break;
      case ConnectorMessageType.DELETE_CARD_NOTE:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)) {
            if (this.cos.hasCardNote(message.cardObject.id)) {
              this.cos.removeCardNote(
                message.cardObject.id,
                message.cardObject.name,
                message.cardObject.cardDeckId,
                message.cardObject.deckType,
                false);
              console.log('DELETE CARD NOTE ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.CHANGE_CARD_NOTE:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)) {
            if (this.cos.hasCardNote(message.cardObject.id)){
              this.cos.addOrUpdateCardNote(
                message.cardNoteObject.noteType,
                message.cardNoteObject.noteText,
                message.cardObject.id,
                message.cardObject.name,
                message.cardObject.deckType,
                message.cardObject.cardDeckId,
                false);
              console.log('CHANGE CARD NOTE ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.ADD_CARD_NOTE:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)) {
            if (!this.cos.hasCardNote(message.cardObject.id)){
              this.cos.addOrUpdateCardNote(
                message.cardNoteObject.noteType,
                message.cardNoteObject.noteText,
                message.cardObject.id,
                message.cardObject.name,
                message.cardObject.deckType,
                message.cardObject.cardDeckId,
                false);
              console.log('ADD CARD NOTE ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.DELETE_LINK_NOTE:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (this.gs.hasGameDesignRelation(message.linkObject.sourceId, message.linkObject.targetId)) {
              if (this.cos.hasRelationNote(message.linkObject.sourceId, message.linkObject.targetId)) {
                this.cos.removeRelationNote(
                  message.linkObject.sourceId,
                  message.linkObject.targetId,
                  message.linkObject.sourceDeckType,
                  message.linkObject.targetDeckType,
                  message.linkObject.sourceName,
                  message.linkObject.targetName,
                  false);
                console.log('DELETE LINK NOTE ON RECEIVED MESSAGE');
              }
            }
          }
        }
        break;
      case ConnectorMessageType.CHANGE_LINK_NOTE:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (this.gs.hasGameDesignRelation(message.linkObject.sourceId, message.linkObject.targetId)) {
              if (this.cos.hasRelationNote(message.linkObject.sourceId, message.linkObject.targetId)) {
                this.cos.addOrUpdateRelationNote(
                  message.linkNoteObject.noteText,
                  message.linkObject.sourceId,
                  message.linkObject.targetId,
                  message.linkObject.sourceName,
                  message.linkObject.targetName,
                  message.linkObject.sourceDeckType,
                  message.linkObject.targetDeckType,
                  false);
                console.log('CHANGE LINK NOTE ON RECEIVED MESSAGE');
              }
            }
          }
        }
        break;
      case ConnectorMessageType.ADD_LINK_NOTE:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (this.gs.hasGameDesignRelation(message.linkObject.sourceId, message.linkObject.targetId)) {
              if (!this.cos.hasRelationNote(message.linkObject.sourceId, message.linkObject.targetId)) {
                this.cos.addOrUpdateRelationNote(
                  message.linkNoteObject.noteText,
                  message.linkObject.sourceId,
                  message.linkObject.targetId,
                  message.linkObject.sourceName,
                  message.linkObject.targetName,
                  message.linkObject.sourceDeckType,
                  message.linkObject.targetDeckType,
                  false);
                console.log('ADD LINK NOTE ON RECEIVED MESSAGE');
              }
            }
          }
        }
        break;
      case ConnectorMessageType.DELETE_LINK:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (this.gs.hasGameDesignRelation(message.linkObject.sourceId, message.linkObject.targetId)) {
              this.gs.removeGameDesignRelation(
                message.linkObject.sourceId,
                message.linkObject.targetId,
                message.linkObject.sourceDeckType,
                false);
              this.cws.updateAllLinkageCards();
              console.log('DELETE LINK ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.ADD_LINK:
        if (message.linkObject !== null) {
          if (this.cws.hasCardWebElement(message.linkObject.sourceId) && this.cws.hasCardWebElement(message.linkObject.targetId)) {
            if (!this.gs.hasGameDesignRelation(message.linkObject.sourceId, message.linkObject.targetId)){
              this.gs.addGameDesignRelationItem(
                message.linkObject.sourceId,
                message.linkObject.sourceName,
                message.linkObject.sourceDeckType,
                message.linkObject.targetId,
                message.linkObject.targetName,
                message.linkObject.targetDeckType,
                message.linkObject.relationId,
                false);
              this.cws.rearrangeConnections(message.linkObject.sourceId, message.linkObject.sourceName);
              console.log('ADDED LINK ON RECEIVED MESSAGE');
            }
          }
        }
        break;
      case ConnectorMessageType.ADD_CARD:
        if (message.cardObject !== null) {
          if (!this.cws.hasCardWebElement(message.cardObject.id)) {
            this.cws.addCardWebElement(
              message.cardObject.id,
              message.cardObject.name,
              message.cardObject.cardDeckId,
              message.cardObject.deckType,
              message.moveEventData.posX,
              message.moveEventData.posY,
              false);
            console.log('ADDED CARD ON RECEIVED MESSAGE');
          }
        }
        break;
      case ConnectorMessageType.MOVE_CARD:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)){
            const cardToMove = this.cws.getCardWebElement(message.cardObject.id);
            this.cws.changeCardLocationInLocationGrid(
              cardToMove.id,
              cardToMove.posX,
              cardToMove.posY,
              message.moveEventData.posX,
              message.moveEventData.posY,
              false);
            console.log('MOVE CARD ON RECEIVED MESSAGE');
          }
        }
        break;
      case ConnectorMessageType.DELETE_CARD:
        if (message.cardObject !== null) {
          if (this.cws.hasCardWebElement(message.cardObject.id)){
            const cardToDelete = this.cws.getCardWebElement(message.cardObject.id);
            // If we have proper locking of selected cards this might not be necessary to deselect selected
            if (this.selectedCardId === cardToDelete.id) {
              this.deselectAllCards();
            }
            console.log('DELETE CARD ON RECEIVED MESSAGE');
            this.cws.removeCardWebElement(cardToDelete, false);
          }
        }
        break;
      default:
        console.error('Invalid message with unknown type received.', message.connectorMessageType);
    }
    // Force manually to detect Changes to update view with locking states (e.g.)
    this.cdRef.detectChanges();
  }


  private updateGuestList(message: ConnectorMessage) {
    if (message.guestList !== null) {
      this.guestList.clear();
      message.guestList.forEach(communityMember => {
        if (this.ownCommunityMember !== undefined) {
          if (communityMember.id !== this.ownCommunityMember.id) {
            this.guestList.set(communityMember.id, communityMember);
          }
        }else{
          this.guestList.set(communityMember.id, communityMember);
        }
      });
      this.cdRef.detectChanges();
    }
  }

  startDragGrid(event: any) {
      if (!this.cardDrag && !this.plusSignDrag) {
          this.gridDrag = true;
          event.preventDefault(); // stop event from reaching anything else than the grid
          event.stopPropagation();
          this.gridDragStartX = event.clientX;
          this.gridDragStartY = event.clientY;
      }else{
        this.deselectAllCards(); this.deselectAllConnections();
      }
  }

  doDragGrid(event: any) {
    if (this.plusSignDrag) {
      this.movePlusSignDrag(event);
    }else{
        if (!this.cardDrag && this.gridDrag) {
            event.preventDefault();
            event.stopPropagation();
            if (event.buttons !== 1) {
                return; // only drag if left mouse button is clicked
            }

            const dragDistanceX = event.clientX - this.gridDragStartX;
            const dragDistanceY = event.clientY - this.gridDragStartY;

            this.viewBoxX -= dragDistanceX * this.zoomFactor;
            this.viewBoxY -= dragDistanceY * this.zoomFactor;

            this.gridDragStartX = event.clientX;
            this.gridDragStartY = event.clientY;

            this.updateViewBox();
        }
    }
  }

  stopDragGrid(event: any): void {
    this.stopPlusSignDrag(event);
  }


  zoom(event: WheelEvent) {
  event.preventDefault();
  event.stopPropagation();

  const svg = this.svgContainer.nativeElement;
  const pt = svg.createSVGPoint();

  pt.x = event.clientX;
  pt.y = event.clientY;

  const svgP = pt.matrixTransform(svg.getScreenCTM().inverse());

  const zoomDelta = Math.sign(event.deltaY) * 4;
  const newZoomLevel = Math.min(300, Math.max(10, this.zoomLevel - zoomDelta));
  const newZoomFactor = 100 / newZoomLevel;
  const oldZoomFactor = this.zoomFactor;

  this.zoomLevel = newZoomLevel;
  this.zoomFactor = newZoomFactor;

  const newViewBoxWidth = this.viewBoxWidth / oldZoomFactor * newZoomFactor;
  const newViewBoxHeight = this.viewBoxHeight / oldZoomFactor * newZoomFactor;

  this.viewBoxX = svgP.x - (svgP.x - this.viewBoxX) / oldZoomFactor * newZoomFactor;
  this.viewBoxY = svgP.y - (svgP.y - this.viewBoxY) / oldZoomFactor * newZoomFactor;

  this.viewBoxWidth = newViewBoxWidth;
  this.viewBoxHeight = newViewBoxHeight;

  this.updateViewBox();
}


  onZoomChange(zoomLevel: number) {
  const oldZoomFactor = this.zoomFactor;

  this.zoomLevel = zoomLevel;
  this.zoomFactor = 100 / zoomLevel;

  this.viewBoxWidth = this.viewBoxWidth / oldZoomFactor * this.zoomFactor;
  this.viewBoxHeight = this.viewBoxHeight / oldZoomFactor * this.zoomFactor;

  this.updateViewBox();
}

  /**
   * svg view will only be updated if attributes change.
   * After one grid drag calculation cycle is done attributes will be updated
   */
  updateViewBox() {
    const svg = this.svgContainer.nativeElement;
    const viewBox = `${this.viewBoxX} ${this.viewBoxY} ${this.viewBoxWidth} ${this.viewBoxHeight}`;
    svg.setAttribute('viewBox', viewBox);
  }

  // *** card and connections logic - drag, select, buttons ***

  private canEdit() {
    return this.shareOption === 'edit';
  }

  selectCard(card: any, webElement: CardWebElement) {
    if (!this.hasCardLock(webElement) && this.canEdit()) {
      this.selectedCardId = +webElement.id;
      this.selectedCardDeckId = +webElement.cardDeckId;
      this.selectedCardDeckType = webElement.cardDeckType;
      this.selectedWebElement = webElement;
      this.isCardSelected = true;
      this.plusSignX =  +card.getAttribute('x');
      this.plusSignY = +card.getAttribute('y');
      this.deselectAllConnections();
    }
  }

  public deselectAllCards() {
    // !this.plusSignDrag needed for selecting connections in firefox (different pointerdown/click event handling)
    if (this.isCardSelected && !this.plusSignDrag) {
      this.selectedWebElement = null;
      this.selectedCardId = 0;
      this.selectedCardDeckId = 0;
      this.isCardSelected = false;
    }
  }

  public deselectAllConnections() {
    // !this.plusSignDrag needed for selecting connections in firefox (different pointerdown/click event handling)
    if (this.isConnectionSelected && !this.plusSignDrag) {
      this.isConnectionSelected = false;
      this.selectedConnection.sourceId = null;
      this.selectedConnection.targetId = null;
      this.selectedConnection.posX = null;
      this.selectedConnection.posY = null;
      this.selectedConnection.pos = null;
      this.selectedConnection.obstaclePatternType = null;
      this.selectedConnection.isLinkageConnection = null;
    }
  }

  public selectLinkageConnection(
    $event: PointerEvent,
    neighbourSourceId: number,
    neighbourTargetId: number,
    gameDesignRelation: { sourceId: number, targetId: number, relationItemId: number},
    deckType: DeckType
  ) {
    if (!this.hasLinkLock(gameDesignRelation.sourceId, gameDesignRelation.targetId) && this.canEdit()) {
      this.isConnectionSelected = true;
      this.selectedConnection.isLinkageConnection = true;
      this.selectedConnection.sourceId = neighbourSourceId;
      this.selectedConnection.targetId = neighbourTargetId;
      this.selectedConnection.posX = this.calculateRelationCoordinates(neighbourSourceId, neighbourTargetId).x;
      this.selectedConnection.posY = this.calculateRelationCoordinates(neighbourSourceId, neighbourTargetId).y;
      this.selectedConnection.pos = this.calculateRelationCoordinates(neighbourSourceId, neighbourTargetId).pos;
      this.selectedConnection.relationItemId = gameDesignRelation.relationItemId;
      this.selectedConnection.obstaclePatternType = deckType;
      this.deselectAllCards();
    }
  }


  public selectConnection(
    sourceId: number,
    targetId: number,
    relationItemId: number,
    obstaclePatternType: string) {
    if (!this.hasLinkLock(sourceId, targetId) && this.canEdit()) {
      this.isConnectionSelected = true;
      this.selectedConnection.isLinkageConnection = false;
      this.selectedConnection.sourceId = sourceId;
      this.selectedConnection.targetId = targetId;
      this.selectedConnection.posX = this.calculateRelationCoordinates(sourceId, targetId).x;
      this.selectedConnection.posY = this.calculateRelationCoordinates(sourceId, targetId).y;
      this.selectedConnection.pos = this.calculateRelationCoordinates(sourceId, targetId).pos;
      this.selectedConnection.relationItemId = relationItemId;

      // DeckType can not be called in the html, therefore a string is passed
      if (obstaclePatternType === 'pattern') {
        this.selectedConnection.obstaclePatternType = DeckType.pattern;
      } else if (obstaclePatternType === 'problem') {
        this.selectedConnection.obstaclePatternType = DeckType.problem;
      }
      this.deselectAllCards();
    }
  }

  // card drag
  startDragElement(event: any, card: any, element: CardWebElement) {
      event.stopPropagation();
      event.preventDefault();
      if (element.cardDeckType !== DeckType.linkage) {
        if (!this.hasCardLock(element) && this.canEdit()) {
          this.gridDrag = false;
          this.cardDrag = true;
          this.draggedCard = card;
          this.pointerEventClickX = event.clientX;
          this.pointerEventClickY = event.clientY;
          this.cardDragStartX = Number(this.draggedCard.getAttribute('x'));
          this.cardDragStartY = Number(this.draggedCard.getAttribute('y'));
          this.hoveredGridX = this.cardDragStartX;
          this.hoveredGridY = this.cardDragStartY;
          this.showHoverCard = true;
          this.cardWeb.cards = this.cardWeb.cards.filter(obj => obj !== element);
          this.cardWeb.cards.push(element);
        }
      }
  }

  @HostListener('document:pointerup' || 'document:touchend', ['$event'])
  public handleUp(event: any) {
    if (this.cardDrag || this.gridDrag) {
      this.gridDrag = false;
      this.cardDrag = false;
      const initialYGrid = this.cws.calculateGridPositionY(this.cardDragStartY, this.cardDragStartX);
      const initialXGrid = this.cws.calculateGridPositionX(this.cardDragStartX);

      if (this.draggedCard) {
        if (!this.cws.checkCardCollision(this.hoveredGridX, this.hoveredGridY)) {
          this.draggedCard.setAttribute('x', this.hoveredGridX);
          this.draggedCard.setAttribute('y', this.hoveredGridY);

          const newXGrid = this.cws.calculateGridPositionX(this.hoveredGridX);
          const newYGrid = this.cws.calculateGridPositionY(this.hoveredGridY, this.hoveredGridX);
          this.cws.changeCardLocationInLocationGrid(
            +this.draggedCard.id, initialXGrid,
            initialYGrid, newXGrid,
            newYGrid);

        } else {
          // Check if card is dragged to position of linkage card
          const hoveredLinkageCard = this.cws.getHoveredLinkageCard(this.hoveredGridX, this.hoveredGridY, this.draggedCard.id);
          // Check if linkageCard is currently Locked to prevent deletion of relation another user is currently working no
          if (hoveredLinkageCard !== undefined && this.getLinkageCardElementLock(hoveredLinkageCard) === null){
            /* Check if hoveredLinkageCard is own linkage card or foreign linkage card
            if (hoveredLinkageCard.linkageSourceIds.includes(+this.draggedCard.id) ||
              hoveredLinkageCard.linkageTargetIds.includes(+this.draggedCard.id)
            ) {
              console.log("OwnLinkageCard");
            } else {
              // hovered linkageCard is foreign LinkageCard - new path has to be found
              console.log("ForeignLinkageCard");
            }*/

            this.draggedCard.setAttribute('x', this.hoveredGridX);
            this.draggedCard.setAttribute('y', this.hoveredGridY);

            const newXGrid = this.cws.calculateGridPositionX(this.hoveredGridX);
            const newYGrid = this.cws.calculateGridPositionY(this.hoveredGridY, this.hoveredGridX);
            this.cws.changeCardLocationInLocationGrid(
                +this.draggedCard.id, initialXGrid,
                initialYGrid, newXGrid,
                newYGrid);

          }else{
            this.draggedCard.setAttribute('x', this.cardDragStartX);
            this.draggedCard.setAttribute('y', this.cardDragStartY);
          }
        }
        this.draggedCard = null;
        this.showHoverCard = false;
      }
    }
  }

  private removeRelatedLinkageCardsForRepositioning(cardId: number) {
    const cardElementsToRearrangeLinkageCards = new Set<CardWebElement>();
    for (let i = 0; i < this.cardWeb.cards.length; i++) {
      const card = this.cardWeb.cards[i];
      if (card.cardDeckType === DeckType.linkage) {
        if (card.linkageSourceIds.includes(cardId) || card.linkageTargetIds.includes(cardId)) {
          for (const sourceId of card.linkageSourceIds) {
            const sourceCard = this.cws.getCardWebElement(sourceId);
            cardElementsToRearrangeLinkageCards.add(sourceCard);
          }
          for (const targetId of card.linkageTargetIds) {
            const targetCard = this.cws.getCardWebElement(targetId);
            cardElementsToRearrangeLinkageCards.add(targetCard);
          }
          this.cws.removeCardFromLocationGrid(card.posX, card.posY);
          this.cardWeb.cards.splice(i--, 1);
        }
      }
    }
    // const sortedArray = Array.from(cardElementsToRearrangeLinkageCards).sort((c1, c2) => c2.posX - c1.posX);
    // const sortedArray = Array.from(cardElementsToRearrangeLinkageCards).sort((c1, c2) => c1.posX - c2.posX);
    return cardElementsToRearrangeLinkageCards;
  }

  private detectSufficientDragDistance(event: any) {
    let sufficientDragDistance = false;
    sufficientDragDistance = Math.abs(event.clientX - this.pointerEventClickX) > 5;
    sufficientDragDistance = sufficientDragDistance || (Math.abs(event.clientY - this.pointerEventClickY) > 5);
    return sufficientDragDistance;
  }

  @HostListener('document:pointermove', ['$event'])
  public handleMove(event: any) {
    event.stopPropagation();
    if (!this.gridDrag && this.cardDrag && this.detectSufficientDragDistance(event)) {
      if (event.buttons !== 1) {
        return;
      }

      this.deselectAllCards();
      const svg = this.svgContainer.nativeElement;
      const point = svg.createSVGPoint();
      point.x = event.clientX;
      point.y = event.clientY;
      const cursorPt = point.matrixTransform(svg.getScreenCTM().inverse());
      this.draggedCard.setAttribute('x', cursorPt.x - 150);
      this.draggedCard.setAttribute('y', cursorPt.y - 200);
      this.hoveredGridX = Math.round((cursorPt.x - 150) / 400) * 400;
      const initialY = (Math.round((cursorPt.y - 150) / 500) * 500);
      if (this.hoveredGridX % 800 === 0) {
        this.hoveredGridY = initialY;
      } else {
        this.hoveredGridY = initialY - 250;
      }
    }
  }

  /**
   * removes the selected element from the editor
   */
  @HostListener('document:keydown.delete', ['$event'])
  @HostListener('document:keydown.backspace', ['$event'])
  onDeleteKey(event: KeyboardEvent) {
    if (this.isCardSelected && !(this.dialogCardNoteIsOpen || this.dialogLinkNoteIsOpen)) {
      this.removeCard();
    }
    if (this.isConnectionSelected && !(this.dialogCardNoteIsOpen || this.dialogLinkNoteIsOpen)) {
      if (this.canSelectedConnectionHaveNote()) {
        this.removeConnection();
      }
    }
  }

  public removeCard() {
    const cardToDelete = this.cardWeb.cards.find(card => card.id === this.selectedCardId);
    if (cardToDelete.cardDeckType === DeckType.linkage) {
      this.cws.removeLinkageCard(cardToDelete);
    }else{
      this.cws.removeCardWebElement(cardToDelete);
    }
    this.deselectAllConnections();
    this.deselectAllCards();
  }

  public removeConnection() {
    if (this.selectedConnection) {
      const ids = this.getOriginalSourceAndTargetIdsForConnection(this.selectedConnection.sourceId, this.selectedConnection.targetId);
      const originalSourceCard = this.cws.getCardWebElement(ids.originalSourceId);
      const originalTargetCard = this.cws.getCardWebElement(ids.originalTargetId);
      const sourceCard = this.cws.getCardWebElement(this.selectedConnection.sourceId);
      const targetCard = this.cws.getCardWebElement(this.selectedConnection.targetId);

      this.cws.removeConnection(sourceCard, targetCard, originalSourceCard, originalTargetCard);

      this.deselectAllConnections();
      this.deselectAllCards();
    }
  }

  public calculateCardXCoordinates(gridPosX: number): number {
    return gridPosX * 400;
  }

  public calculateCardYCoordinates(gridPosY: number, gridPosX: number) {
    if ((gridPosX * 400) % 800 === 0) {
      return (gridPosY / 2) * 500;
    } else {
      return (((gridPosY - 1) / 2) * 500) + 250;
    }
  }

  private getLinkageCardForConnection(sourceCard: CardWebElement, targetCard: CardWebElement) {
    let linkageCard: CardWebElement = null;
    if (sourceCard.cardDeckType === DeckType.linkage) {
      if (targetCard.cardDeckType !== DeckType.linkage) {
        linkageCard = sourceCard;
      }
    }else{
      if (targetCard.cardDeckType === DeckType.linkage) {
        linkageCard = targetCard;
      }
    }
    return linkageCard;
  }

  private getLinkageTypeForSelectedConnection(sourceCard: CardWebElement, targetCard: CardWebElement){
    // Check if intermediate LinkageConnection
    const linkageCard = this.getLinkageCardForConnection(sourceCard, targetCard);
    return this.cws.getOverallLinkageType(linkageCard);
  }

  canSelectedConnectionHaveNote() {
    if (this.selectedConnection) {
      if (!this.selectedConnection.isLinkageConnection) {
        return true;
      }

      const sourceCard = this.cws.getCardWebElement(this.selectedConnection.sourceId);
      const targetCard = this.cws.getCardWebElement(this.selectedConnection.targetId);
      if (sourceCard.cardDeckType === DeckType.linkage && targetCard.cardDeckType === DeckType.linkage) {
        return false;
      }
      const linkageType = this.getLinkageTypeForSelectedConnection(sourceCard, targetCard);
      if (linkageType === LinkageType.oneToMany) {
        return sourceCard.cardDeckType === DeckType.linkage;
      }else if (linkageType === LinkageType.manyToOne) {
        return targetCard.cardDeckType === DeckType.linkage;
      }else if (linkageType === LinkageType.oneToOne) {
        return targetCard.cardDeckType === DeckType.linkage;
      }else{
        console.error('Problem with deferred linkageType for selected Connection');
        return false;
      }
    }
  }

  public  calculateRelationCoordinates(sourceId: number, targetId: number) {
    const sourceCard = this.cardWeb.cards.find(card => card.id === sourceId);
    const targetCard = this.cardWeb.cards.find(card => card.id === targetId);
    let x = 0;
    let y = 0;
    let pos = 'default';
    if (sourceCard !== undefined && targetCard !== undefined) {
      if (sourceCard.posX + 1 === targetCard.posX && sourceCard.posY + 1 === targetCard.posY) {
        x = this.calculateCardXCoordinates(sourceCard.posX) + 267;
        y = this.calculateCardYCoordinates(sourceCard.posY, sourceCard.posX) + 335;
        pos = 'right';
        return {x, y, pos};
      } else if (sourceCard.posX - 1 === targetCard.posX && sourceCard.posY + 1 === targetCard.posY) {
        x = this.calculateCardXCoordinates(sourceCard.posX) - 132;
        y = this.calculateCardYCoordinates(sourceCard.posY, sourceCard.posX) + 335;
        pos = 'left';
        return {x, y, pos};
      } else if (sourceCard.posX === targetCard.posX && sourceCard.posY + 2 === targetCard.posY) {
        x = this.calculateCardXCoordinates(sourceCard.posX) + 118;
        y = this.calculateCardYCoordinates(sourceCard.posY, sourceCard.posX) + 415;
        pos = 'bottom';
        return {x, y, pos};
      }
    }
    return {x, y, pos};
  }

  public dropNewCard(event: CdkDragDrop<any>): void {
    if (this.canEdit()) {
      this.deselectAllCards();
      this.deselectAllConnections();
      const svg = this.svgContainer.nativeElement;
      const point = svg.createSVGPoint();
      point.x = event.dropPoint.x;
      point.y = event.dropPoint.y;

      const cursorPt = point.matrixTransform(svg.getScreenCTM().inverse());
      if (!this.cws.checkCardOutOfBounds(cursorPt.x, cursorPt.y)) {
        this.cws.addDroppedCard(event.item.data.cp.id, event.item.data.cp.name,
          event.item.data.cp.cardDeckId, event.item.data.cardDeck.type,
          cursorPt.x, cursorPt.y);
      }
    }
  }

  /**
   * selects a card's primary connection buttons and forwards the click action
   * by that no extra routerlink and no extra data has to be requested
   */
  public openSideMenu(preference: ('left' | 'right' | 'bottom')) {
    const foreignObjectElement = this.svgContainer.nativeElement.getElementById(`${this.selectedCardId}`);
    if (foreignObjectElement) {
      const buttonElement = foreignObjectElement.querySelector('#sideMenuButton');
      let clicked = false;
      if (buttonElement instanceof HTMLTableCellElement) {
        buttonElement.click(); // Simulate a click on the button.
        clicked = true;
      }else if (buttonElement instanceof HTMLDivElement) {
        // Open Menu for Linkage Card
        buttonElement.click(); // Simulate a click on the button.
        clicked = true;
      }
      if (clicked) {

        this.rightSidenav.openedChange.subscribe( next => {
            if (!next) {
              // with sideNavIsOpen it can be checked if the primary LinkMenue is open
              if (this.sideNavIsOpen) {
                // CALL WEBSOCKET CONNECTION
                const pattern = this.cws.getCardWebElement(this.selectedCardId);
                const cardObject = this.mfs.buildCardObject(pattern.cardDeckId, pattern.id, pattern.cardDeckType, pattern.name);
                const messageObject = this.mfs.createMessageLeaveCardLink(cardObject);
                this.oes.handleAction(messageObject);
                this.sideNavIsOpen = !this.sideNavIsOpen;
              }
              this.sideNavIsOpen = false;
            }else {
              if (!this.sideNavIsOpen){
                // CALL WEBSOCKET CONNECTION
                const pattern = this.cws.getCardWebElement(this.selectedCardId);
                const cardObject = this.mfs.buildCardObject(pattern.cardDeckId, pattern.id, pattern.cardDeckType, pattern.name);
                const messageObject = this.mfs.createMessageEnterCardLink(cardObject);
                this.oes.handleAction(messageObject);
                this.sideNavIsOpen = !this.sideNavIsOpen;
              }
            }
          });
      }
    }
    this.cws.setConnectionPreference(preference, this.selectedWebElement.posX, this.selectedWebElement.posY);
  }


  openCardNodeMenu($event: PointerEvent) {
    this.dialogCardNoteIsOpen = true;
    const sourceCard = this.cws.getCardWebElement(this.selectedCardId);
    this.noteDialog.open(NoteDialogElementComponent,
      {
          data: {
          sourceCardDeckId: sourceCard.cardDeckId,
          sourceCardPatternId: sourceCard.id,
          sourceCardDeckType: sourceCard.cardDeckType,
          sourceCardPatternName: sourceCard.name,
          designName: this.cardWeb.name,
          createdDateTime: this.cardWeb.createdDateTime
        },
        autoFocus: false
      });

    this.noteDialog.afterAllClosed.subscribe(result => {
      this.dialogCardNoteIsOpen = false;
    });
    // CALL WEBSOCKET CONNECTION
    const cardObject = this.mfs.buildCardObject(sourceCard.cardDeckId, sourceCard.id, sourceCard.cardDeckType, sourceCard.name);
    const messageObject = this.mfs.createMessageEnterCardNote(cardObject);
    this.oes.handleAction(messageObject);

    $event.stopPropagation();
    $event.preventDefault();
  }


  openRelationNoteMenuForSelectedConnection($event: PointerEvent) {
    if (this.selectedConnection) {
      const ids = this.getOriginalSourceAndTargetIdsForConnection(
        this.selectedConnection.sourceId, this.selectedConnection.targetId);
      this.dialogLinkNoteIsOpen = true;
      const sourceCard = this.cws.getCardWebElement(ids.originalSourceId);
      const targetCard = this.cws.getCardWebElement(ids.originalTargetId);
      this.noteDialog.open(NoteDialogRelationComponent,  {
        data: {
          targetCardPatternId: ids.originalTargetId,
          sourceCardPatternId: ids.originalSourceId,
          sourceCardPatternName: sourceCard.name,
          targetCardPatternName: targetCard.name,
          sourceCardDeckType: sourceCard.cardDeckType,
          targetCardDeckType: targetCard.cardDeckType,
          designName: this.cws.getCustomCardWeb().name,
          createdDateTime: this.cws.getCustomCardWeb().createdDateTime
        },
        autoFocus: false
      });

      this.noteDialog.afterAllClosed.subscribe(result => {
        this.dialogLinkNoteIsOpen = false;
      });


      // CALL WEBSOCKET CONNECTION
      const linkObject = this.mfs.buildLinkObject(
        ids.originalSourceId, ids.originalTargetId, sourceCard.cardDeckType, targetCard.cardDeckType, sourceCard.name, targetCard.name);
      const messageObject = this.mfs.createMessageEnterLinkNote(linkObject);
      this.oes.handleAction(messageObject);

      $event.stopPropagation();
      $event.preventDefault();
    }
  }

  /**
   * Verhalten dieser Funktion ist merkwürdig, funktioniert aber. Was die Funktion nicht macht:
   * Sie ermittelt nicht die originalen Source und TargetIds für jede beliebige neighbourSource und neighbourTarget.
   * @param neigbourSourceId
   * @param neighbourTargetId
   * @private
   */
  private getOriginalSourceAndTargetIdsForConnection(neigbourSourceId: number, neighbourTargetId: number) {
    let originalSourceId = neigbourSourceId;
    let originalTargetId = neighbourTargetId;
    const sourceCard = this.cws.getCardWebElement(neigbourSourceId);
    const targetCard = this.cws.getCardWebElement(neighbourTargetId);
    const linkageCard = this.getLinkageCardForConnection(sourceCard, targetCard);
    if (linkageCard !== null) {
      const linkageType = this.getLinkageTypeForSelectedConnection(sourceCard, targetCard);
      if (linkageType === LinkageType.oneToMany) {
        originalSourceId = linkageCard.linkageSourceIds[0];
        originalTargetId = targetCard.id;
      }else if (linkageType === LinkageType.manyToOne || linkageType === LinkageType.oneToOne) {
        originalSourceId = sourceCard.id;
        originalTargetId = linkageCard.linkageTargetIds[0];
      }
    }
    return {originalSourceId, originalTargetId};
  }

  public canConnectLeft() {
    return this.cws.canConnectLeft(this.selectedWebElement.posX, this.selectedWebElement.posY, this.selectedWebElement.id);
  }

  public canConnectRight() {
    return this.cws.canConnectRight(this.selectedWebElement.posX, this.selectedWebElement.posY, this.selectedWebElement.id);
  }

  public canConnectBottom() {
    return this.cws.canConnectBottom(this.selectedWebElement.posX, this.selectedWebElement.posY, this.selectedWebElement.id);
  }

  public canHaveNote(): boolean {
    return this.cws.canHaveNote(this.selectedWebElement.id);
  }

  public hasCardNote(cardId: number): boolean {
    return this.cos.hasCardNote(cardId);
  }

  getCardNoteText(cardId: number) {
    const cardNote = this.customObjects.cardNotes.find(co => co.sourceId === cardId);
    return cardNote.text;
  }

  getCardNoteType(cardId: number) {
    const cardNote = this.customObjects.cardNotes.find(co => co.sourceId === cardId);
    return cardNote.type;
  }

  hasRelationNote(sourceId: number, targetId: number) {
    return this.cos.hasRelationNote(sourceId, targetId);
  }

  private hasSelectedNote() {
    let originalSourceId: number = this.selectedConnection.sourceId;
    let originalTargetId: number = this.selectedConnection.targetId;
    if (this.selectedConnection.isLinkageConnection) {
      const ids = this.getOriginalSourceAndTargetIdsForConnection(this.selectedConnection.sourceId, this.selectedConnection.targetId);
      originalSourceId = ids.originalSourceId;
      originalTargetId = ids.originalTargetId;
    }
    return this.cos.hasRelationNote(originalSourceId, originalTargetId);
  }

  getRelationNoteText(sourceId: number, targetId: number) {
    const relationNote = this.customObjects.relationNotes.find(
      note => (note.sourceId === sourceId && note.targetId === targetId)
    );
    return relationNote.text;
  }

  getRelationNoteType(sourceId: number, targetId: number) {
    const relationNote = this.customObjects.relationNotes.find(
      note => (note.sourceId === sourceId && note.targetId === targetId)
    );
    return relationNote.type;
  }

  getAllNoteRelations() {
    const allNoteRelations: {
      sourceId: number,
      targetId: number,
      neighbourSourceId: number,
      neighbourTargetId: number,
      relationItemId: number,
      cordX: number,
      cordY: number,
      deckType: DeckType,
      isLinkageConnection: boolean}[] = [];
    const allDesignRelations = this.getDesignRelations();
    for (const designRelation of allDesignRelations) {
      allNoteRelations.push({
        sourceId: designRelation.gameDesignRelation.sourceId,
        targetId: designRelation.gameDesignRelation.targetId,
        neighbourSourceId: designRelation.sourceCardId,
        neighbourTargetId: designRelation.targetCardId,
        relationItemId: designRelation.gameDesignRelation.relationItemId,
        cordX: designRelation.cordX,
        cordY: designRelation.cordY,
        deckType: designRelation.deckType,
        isLinkageConnection: designRelation.isLinkageConnection
      });
    }
    const allLinkageRelations = this.getLinkageCardRelations();
    for (const linkageRelation of allLinkageRelations) {
      const ids = this.getOriginalSourceAndTargetIdsForConnection(linkageRelation.sourceId, linkageRelation.targetId);
      allNoteRelations.push({
        sourceId: ids.originalSourceId,
        targetId: ids.originalTargetId,
        neighbourSourceId: linkageRelation.sourceId,
        neighbourTargetId: linkageRelation.targetId,
        relationItemId: linkageRelation.relationItemId,
        cordX: this.calculateRelationNoteCoordinate(linkageRelation.sourceId, linkageRelation.targetId).x,
        cordY: this.calculateRelationNoteCoordinate(linkageRelation.sourceId, linkageRelation.targetId).y,
        deckType: linkageRelation.deckType,
        isLinkageConnection: true
      });
    }
    return allNoteRelations;
  }

  getDesignRelations() {
    const gameDesignRelations = this.fetchDesignRelations(this.gameDesign.gameDesignRelations);
    const gameDesignProblemRelations = this.fetchDesignRelations(this.gameDesign.gameDesignProblemRelations);
    return [...gameDesignRelations, ...gameDesignProblemRelations];
  }

  private fetchDesignRelations(allRelations: GameDesignRelation[]) {
    const designRelations: {
      gameDesignRelation: GameDesignRelation,
      deckType: DeckType,
      cordX: number,
      cordY: number,
      isLinkageConnection: boolean,
      sourceCardId: number,
      targetCardId: number
    }[] = [];
    const allLinkageCards = this.cardWeb.cards.filter(card => card.cardDeckType === DeckType.linkage);
    let cord: {x: number, y: number};
    let isLinkageConnection = false;
    let sourceCardId: number;
    let targetCardId: number;
    for (const relation of allRelations) {
      const linkageCards = allLinkageCards.filter(linkageCard =>
        linkageCard.linkageSourceIds.includes(relation.sourceId) && linkageCard.linkageTargetIds.includes(relation.targetId));
      if (linkageCards.length > 0) {
        const linkageType = this.cws.getOverallLinkageType(linkageCards[0]);
        if (linkageType === LinkageType.manyToOne || linkageType === LinkageType.oneToOne) {
          const neighbourDownIds = this.cws.getNeighbourCardIds(relation.sourceId, 'down').values();
          for (const neighbourDownId of neighbourDownIds) {
            const adjacentLinkageCard = linkageCards.find(linkageCard => linkageCard.id === neighbourDownId);
            if (adjacentLinkageCard !== undefined) {
              cord = this.calculateRelationNoteCoordinate(relation.sourceId, adjacentLinkageCard.id);
              isLinkageConnection = true;
              sourceCardId = relation.sourceId;
              targetCardId = adjacentLinkageCard.id;
            }
          }
        }else if (linkageType === LinkageType.oneToMany) {
          for (const neighbourUpId of this.cws.getNeighbourCardIds(relation.targetId, 'up').values()) {
            const adjacentLinkageCard = linkageCards.find(linkageCard => linkageCard.id === neighbourUpId);
            if (adjacentLinkageCard !== undefined) {
              cord = this.calculateRelationNoteCoordinate(adjacentLinkageCard.id, relation.targetId);
              isLinkageConnection = true;
              sourceCardId = adjacentLinkageCard.id;
              targetCardId = relation.targetId;
            }
          }
        }
      }else{
        cord = this.calculateRelationNoteCoordinate(relation.sourceId, relation.targetId);
        sourceCardId = relation.sourceId;
        targetCardId = relation.targetId;
        isLinkageConnection = false;
      }
      if (cord !== undefined){
        designRelations.push({
          gameDesignRelation: relation,
          deckType: DeckType.pattern,
          cordX: cord.x,
          cordY: cord.y,
          isLinkageConnection,
          sourceCardId,
          targetCardId
        });
      }
    }
    return designRelations;
  }

  calculateRelationNoteCoordinate(sourceId: number, targetId: number){
    const coordinate = this.calculateRelationCoordinates(sourceId, targetId);
    let x = coordinate.x;
    let y = coordinate.y;
    if (coordinate.pos === 'bottom') {
      y = y + 20;
      x = x - 71;
    }else if (coordinate.pos === 'left' || coordinate.pos === 'right'){
      y = y + 20;
      x = x - 23;
    }
    return {x, y};
  }

  calculateRelationDeleteCoordinates(pos = '') {
    let x: number;
    let y: number;
    if (pos === 'bottom') {
        x = this.selectedConnection.posX - 40;
        y = this.selectedConnection.posY + 35;
        if (this.hasSelectedNote()) {
          x = x - 60;
          y = y + 25;
        }
    } else {
        // pos === 'left' or 'right'
        x = this.selectedConnection.posX + 60;
        y = this.selectedConnection.posY + 50;
        if (this.hasSelectedNote()) {
            y = y + 85;
        }
    }
    return {x, y};
  }

    calculateRelationNoteMenuCoordinates(pos = '') {
        let x: number;
        let y: number;
        if (pos === 'bottom') {
            x = this.selectedConnection.posX + 55;
            y = this.selectedConnection.posY + 25;
            if (this.hasSelectedNote()) {
                x = x + 66;
                y = y + 27;
            }
        } else {
            // pos === 'left' or 'right'
            x = this.selectedConnection.posX + 50;
            y = this.selectedConnection.posY - 50;
            if (this.hasSelectedNote()) {
                y = y + 0;
            }
        }
        return {x, y};
    }

  startPlusSignDrag($event: PointerEvent, preference: ('left' | 'right' | 'bottom')) {
    if (!this.plusSignDrag) {
      const neighboursMap = this.cws.getNeighbourCardIds(this.selectedCardId, 'down');
      if (neighboursMap.has(preference)) {
        switch (preference) {
          case 'left': {
            // getting the right bound 267 has to be added to posX as thi is the width of a card
            this.collisionCoordinate = this.cws.calculateCardXCoordinates(this.selectedWebElement.posX - 1) + 267;
            this.initialMousePos = $event.x;
            this.mouseMoveDragTargetCardId = neighboursMap.get('left');
            break;
          }
          case 'right': {
            this.collisionCoordinate = this.cws.calculateCardXCoordinates(this.selectedWebElement.posX + 1);
            this.initialMousePos = $event.x;
            this.mouseMoveDragTargetCardId = neighboursMap.get('right');
            break;
          }
          case 'bottom': {
            this.collisionCoordinate = this.cws.calculateCardYCoordinates(this.selectedWebElement.posY + 2, this.selectedWebElement.posX);
            this.initialMousePos = $event.y;
            this.mouseMoveDragTargetCardId = neighboursMap.get('bottom');
            break;
          }
          default: {}
        }
        this.mouseMoveDragLeft = 0;
        this.mouseMoveDragBottom = 0;
        this.mouseMoveDragRight = 0;
        this.plusSignDrag = true;
        this.dragDirectionPlusSign = preference;
      }else{
        this.plusSignNoDrag = true;
        this.dragDirectionPlusSign = preference;
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }

  movePlusSignDrag($event: PointerEvent) {
    if (this.plusSignDrag && this.dragDirectionPlusSign) {
      if (this.checkIfPlusSignCollidesWithNeighbour(this.collisionCoordinate, this.dragDirectionPlusSign)) {
        const targetCardWebElement = this.cws.getCardWebElement(this.mouseMoveDragTargetCardId);
        this.addCustomRelation(this.selectedWebElement, targetCardWebElement);
      }else {
        switch (this.dragDirectionPlusSign) {
          case 'left': {
            let diff = this.initialMousePos - $event.x;
            diff = diff * this.zoomFactor * 1.1;
            if (diff > 0) {
              this.mouseMoveDragLeft = diff;
            }
            break;
          }
          case 'right': {
            let diff = this.initialMousePos - $event.x;
            diff = diff * this.zoomFactor * 1.1;
            if (diff < 0) {
              this.mouseMoveDragRight = diff;
            }
            break;
          }
          case 'bottom': {
            let diff = this.initialMousePos - $event.y;
            diff = diff * this.zoomFactor * 1.1;
            if (diff < 0) {
              this.mouseMoveDragBottom = diff;
            }
            break;
          }
          default: {}
        }
      }
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  stopPlusSignDrag($event: PointerEvent) {
    if (this.plusSignDrag) {
      this.mouseMoveDragLeft = 0;
      this.mouseMoveDragRight = 0;
      this.mouseMoveDragBottom = 0;
      this.mouseMoveDragTargetCardId = 0;
      this.plusSignDrag = false;
      let diff = 0;
      switch (this.dragDirectionPlusSign) {
        case 'bottom': {
          diff = this.initialMousePos - $event.y;
          break;
        }
        default: {
          // in case of left or right
          diff = this.initialMousePos - $event.x;
        }
      }
      diff = diff * this.zoomFactor * 0.9;
      if (Math.abs(diff) < 10){
        this.openSideMenu(this.dragDirectionPlusSign);
      }
      this.dragDirectionPlusSign = undefined;
    }else {
      if (this.plusSignNoDrag) {
        this.openSideMenu(this.dragDirectionPlusSign);
        this.plusSignNoDrag = false;
      }
    }
  }

  checkIfPlusSignCollidesWithNeighbour(collisionCoord: number, preference: 'left' | 'right' | 'bottom') {
    let actualPositionSVGPlus = 0;
    switch (preference) {
      case 'left': {
        if (!this.svgPlusSignLeft) {
          return false;
        }
        actualPositionSVGPlus = this.svgPlusSignLeft.nativeElement.x.baseVal.value;
        if (actualPositionSVGPlus <= collisionCoord) {
          return true;
        }
        break;
      }
      case 'right': {
        if (!this.svgPlusSignRight) {
          return false;
        }
        actualPositionSVGPlus = this.svgPlusSignRight.nativeElement.x.baseVal.value;
        // + 20 is the radius of the PlusSign circle
        if (actualPositionSVGPlus + 20 >= collisionCoord) {
          return true;
        }
        break;
      }
      case 'bottom': {
        if (!this.svgPlusSignBottom) {
          return false;
        }
        actualPositionSVGPlus = this.svgPlusSignBottom.nativeElement.y.baseVal.value;
        // + 20 is the radius of the PlusSign circle
        if (actualPositionSVGPlus + 20 >= collisionCoord) {
          return true;
        }
        break;
      }
      default: {
        return false;
      }
    }
  }

  addCustomRelation(selectedSourceCard: CardWebElement, targetCard: CardWebElement) {
    let originalSourceCard: CardWebElement = null;
    let originalTargetCard: CardWebElement = null;
    let cardToRearrange: CardWebElement = null;
    if (selectedSourceCard.cardDeckType === DeckType.linkage) {
      if (selectedSourceCard.linkageType === LinkageType.oneToOne || selectedSourceCard.linkageType === LinkageType.oneToMany) {
        originalSourceCard = this.cws.getCardWebElement(selectedSourceCard.linkageSourceIds[0]);
        cardToRearrange = originalSourceCard;
      }
    }else{
      originalSourceCard = selectedSourceCard;
    }
    if (targetCard.cardDeckType === DeckType.linkage) {
      if (targetCard.linkageType === LinkageType.oneToOne || targetCard.linkageType === LinkageType.manyToOne) {
        originalTargetCard = this.cws.getCardWebElement(targetCard.linkageTargetIds[0]);
        cardToRearrange = originalTargetCard;
      }
    }else{
      originalTargetCard = targetCard;
    }
    if (originalSourceCard !== null && originalTargetCard !== null) {
      this.gs.addGameDesignRelationItem(
          originalSourceCard.id,
          originalSourceCard.name,
          originalSourceCard.cardDeckType,
          originalTargetCard.id,
          originalTargetCard.name,
          originalTargetCard.cardDeckType,
          originalSourceCard.id * 10 + originalTargetCard.id
      );
    }
    if (cardToRearrange !== null) {
      this.cws.rearrangeConnections(cardToRearrange.id, cardToRearrange.name);
    }
  }

  getLinkageCardRelations() {
    const linkageCardRelations = new Set<{
      sourceId: number,
      targetId: number,
      relationItemId: number,
      deckType: DeckType}
    >();
    for (const linkageCard of this.cardWeb.cards.filter(card => card.cardDeckType === DeckType.linkage)) {
      if (linkageCard !== undefined) {
        // Add all outer and upper relations first
        if (linkageCard.linkageType === LinkageType.oneToMany) {
          for (const neighbourUp of this.cws.getNeighbourCardsForLinkageCard('up', linkageCard)) {
            if (neighbourUp.cardDeckType !== DeckType.linkage) {
              linkageCardRelations.add({
                sourceId: neighbourUp.id,
                targetId: linkageCard.id,
                relationItemId: -1,
                deckType: neighbourUp.cardDeckType
              });
            }
          }
        }

        // Add all outer and all lower relations second
        for (const neighbourDown of this.cws.getNeighbourCardsForLinkageCard('down', linkageCard)) {
          let sourceCardDeck: DeckType;
          if (linkageCard.linkageType === LinkageType.oneToMany || linkageCard.linkageType === LinkageType.oneToOne) {
            const sourceCard = this.cws.getCardWebElement(linkageCard.linkageSourceIds[0]);
            sourceCardDeck = sourceCard.cardDeckType;
          }else{
            sourceCardDeck = DeckType.linkage;
          }
          linkageCardRelations.add({
            sourceId: linkageCard.id,
            targetId: neighbourDown.id,
            relationItemId: -1,
            deckType: sourceCardDeck
          });
        }
      }
    }
    return linkageCardRelations;
  }

  getAvatarTemplateUrl(avatarTemplate: string): string {
    return this.ccc.getAvatarTemplateUrl(avatarTemplate);
  }
}
